<template>
  <div id="">
    <p>
      北京科百宏业科技有限公司（以下简称“我们”或“北京科百”）尊重并致力于保护个人信息与隐私。
    </p>
    <p>
      科百智汇APP（以下简称“APP”）承诺严格遵守适用法律法规和监管要求，并高度尊重您的个人信息相关合法权利，为完整了解我们的基本信息、我们的个人信息与隐私保护原则等相关内容，请阅读《科百智汇APP用户隐私协议》（以下简称“本协议”）。
    </p>
    <p>本协议拟帮助客户和用户了解以下内容：</p>
    <div>
      <p>1.我们如何收集使用个人信息</p>
      <p>2.我们如何保留和披露您的个人信息</p>
      <p>3.我们如何保护您的个人信息</p>
      <p>4.您的个人信息权利</p>
      <p>5.APP申请权限说明</p>
      <p>6.第三方SDK集成</p>
      <p>7.自启动和关联启动</p>
      <p>8.账号注销流程</p>
      <p>9.如何联系我们</p>
      <p>10.隐私协议如何更新</p>
    </div>
    <p>
      本协议中，“个人信息”指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者关联、反映出特定自然人活动情况的各种信息。如无其他说明，本协议下的其他相关定义和术语具有与《网络安全法》《信息安全技术
      个人信息安全规范》等法律法规、规范性文件、国家标准中相同的含义。
    </p>
    <p>正文</p>
    <p>1.我们如何收集使用个人信息</p>
    <p>
      APP在不同的业务场景下，开展多种多样的业务。我们确保所收集和处理的个人信息已取得您的完整、有效授权同意，但以下情况除外：
    </p>
    <p>1）与履行法律法规规定的义务相关的；</p>
    <p>2）与国家安全、国防安全直接相关的；</p>
    <p>3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p>4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
    <p>5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
    <p>6）所涉及的个人信息是您自行向社会公众公开的；</p>
    <p>7）根据您的要求签订和履行合同所必需的；</p>
    <p>
      8）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开、合法的公开数据集等渠道；
    </p>
    <p>9）维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
    <p>10）个人信息控制者为新闻单位，且其开展合法的新闻报道所必需的；</p>
    <p>
      11）个人信息控制者为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果
      时，对结果中所包含的个人信息进行去标识化处理的。
    </p>
    <p>1.1. 我们收集哪些个人信息及使用目的</p>
    <p>就本APP而言，我们将收集、使用您的相关个人信息，主要包括科百账号登录，操作记录；</p>
    <p>
      主要是为了简化您重复登录的步骤、存储您的偏好、帮助您判断账户或数据安全，或者自动记录某些信息（如日期/时间戳、点击流数据等）以分析、管理我们的APP。
    </p>
    <p>
      以及读取您的设备标识符（包括Android ID、GAID、OAID、UAID、IDFA，用于确认您的设备）、MAC地址
      (包含后台读取，用于确认您的设备，对您设备进行精准推送)、读取您的软件列表及软件运行列表信息（包含所有已安装应用的包名和应用名，查看是否有其他接入极光推送的应用，使用长链保活机制，来提高您推送到达率）、网络信息SSID和BSSID、识别手机身份MEID。
    </p>
    <p>2. 我们如何保留和披露您的个人信息</p>
    <p>
      除非有可适用的法律法规或监管规定明确要求，我们将根据实现处理目的所需的最短时间内保留您的个人信息。
    </p>
    <p>
      此外，根据《网络安全法》等强制性法律法规要求，我们将切实保留网络日志不少于六个月。
    </p>
    <p>
      除非适用的法律法规或监管规定明确要求，我们不会以任何形式、出于任何目的对除客户以外的外部第三方共享和披露本APP下涉及的个人信息。
    </p>
    <p>3. 我们如何保护您的个人信息</p>
    <p>
      我们已采取了合理、可行的管理措施和技术措施，以保护所处理的个人信息并应对个人信息安全事件。但是请注意，虽然我们采取了合理的措施保护您的个人信息，但没有任何APP、Internet传输、计算机系统或无线连接是绝对安全的。
    </p>
    <p>具体而言，本APP下，我们用以保护您提供的个人信息的主要安全防护措施包括但不限于：</p>
    <p>
      1）我们会在可行的情况下及时将您的个人信息进行去标识化处理，从而降低其他组织或个人重新识别到您的风险；
    </p>
    <p>
      2）我们会定期审查个人信息处理的方式（包括物理性安全措施），并不断强化API和SDK等技术工具的安全性；
    </p>
    <p>
      3）我们将不断努力保障您的个人信息安全，并实施传输全程安全加密等保障手段，以免您的个人信息在未经授权的情
      况下被访问、使用或披露。
    </p>
    <p>4. 您的个人信息权利</p>
    <p>
      我们高度尊重您依法享有的个人信息相关合法权利。以下我们列出了您的权利，以及我们将如何保护这些权利。请注意，针对具体的请求，出于安全考虑，在处理您的请求前，我们可能需要先行验证您的身份。
    </p>
    <p>
      1）知情权：我们致力于提升个人信息处理的透明性，并将通过本协议及其他相关法律文本向您告知我们如何处理您的个人信息。
    </p>
    <p>2）访问权：您有权访问您的个人信息。</p>
    <p>3）更正权：当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。</p>
    <p>
      4）删除权：若我们没有合法理由继续持有并处理您的信息，您可以向我们要求删除您的个人信息。
    </p>
    <p>一般而言，我们会在三十天内或法律法规规定的期限内尽快回复，但以下情形除外：</p>
    <p>1）与履行法律法规规定的义务相关的；</p>
    <p>2）与国家安全、国防安全直接相关的；</p>
    <p>3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p>4）与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
    <p>5）有充分证据表明您可能存在主观恶意或滥用权利的；</p>
    <p>6）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
    <p>7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
    <p>8）涉及商业秘密的。</p>
    <p>5.APP申请权限说明</p>
    <p>在APP运行中，为了您的正常使用服务，我们及第三方将进行权限申请，以下为具体说明：</p>
    <p>1）读取设备信息</p>
    <p>权限说明：用于获取 IMEI 码进行用户活跃、留存等数据统计</p>
    <p>权限声明代码：READ_PHONE_STATE</p>
    <p>2）相机</p>
    <p>权限说明：用于拍照AI识别功能中，获取图片数据</p>
    <p>权限声明代码：CAMERA</p>
    <p>3）调用外拨电话</p>
    <p>权限说明：方便用户咨询，反馈问题，提供技术支持</p>
    <p>权限声明代码：CALL_PHONE</p>
    <p>4）获取录音权限</p>
    <p>权限说明：用于用户通过语音识别执行部分指令</p>
    <p>权限声明代码：RECORD_AUDIO</p>
    <p>5）获取位置权限</p>
    <p>权限说明：用于获取实时位置，生成历史轨迹、地理围栏</p>
    <p>权限声明代码：ACCESS_FINE_LOCATION</p>
    <p>6. 第三方SDK集成</p>
    <p>在APP运行中，我们还集成了一些第三方SDK，以下为具体说明：</p>
    <p>1）极光推送</p>
    <p>
      SDK说明：SDK将根据业务功能实现之最⼩必要进⾏⽤户个⼈信息的收集。具体为读取您的设备标识符（包括Android ID、GAID、OAID、UAID、IDFA，用于确认您的设备）、MAC地址
      (包含后台读取，用于确认您的设备，对您设备进行精准推送)、读取您的软件列表及软件运行列表信息（包含所有已安装应用的包名和应用名，查看是否有其他接入极光推送的应用，使用长链保活机制，来提高您推送到达率）、自启动和关联启动（确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息）、网络信息SSID和BSSID、识别手机身份MEID、位置信息（用于生成用户画像）。
    </p>
    <p>SDK包名：cn.jpush.android</p>
    <p>2）Flutter嵌入</p>
    <p>SDK说明：读取您的设备标识符（包括Android ID、GAID、OAID、UAID、IDFA，用于确认您的设备）</p>
    <p>SDK包名：io.flutter.embedding</p>
    <p>3）百度地图定位</p>
    <p>SDK说明：读取您的实时位置信息，用于实现应用内的历史轨迹和地理围栏功能</p>
    <p>SDK包名：com.baidu.location</p>
    <p>7. 自启动和关联启动</p>
    <p>
      1）为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用自启动能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。
    </p>
    <p>
      2）当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容；在未征得您同意的情况下，则不会有自启动或关联启动。
    </p>

    <p>8. 账号注销流程</p>
    <p>
      如果您需要注销账号，请向 kb_data@kebaiiot.com
      发送邮件，我们将在3个工作日内为您人工注销账号。
    </p>
    <p>9. 如何联系我们</p>
    <p>
      如您有任何需要，我们建议您向和您对接的商务直接提出请求，并由其视情况向我们转交。我们会在收到您的请求后尽快进行回应。如您确有需要，您可以通过向
      kb_data@kebaiiot.com发送邮件联系我们，为确保您的请求清晰、明确，请在前述邮件中提供：
    </p>
    <p>1）您的姓名（名称）和联系方式；</p>
    <p>2）您的详细请求、意见和/或相应的链接。</p>
    <p>10. 本协议如何更新</p>
    <p>
      我们保留不时更新或修改本协议政策的权利。但未经您明确同意，我们不会削减您按照本协议所应享有的权利。您可通过本页面查看最新版本的隐私协议。对于重大变更，我们会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件等方式发送通知，说明具体的变更内容）。
      本协议所指的重大变更包括但不限于：
    </p>

    <p>
      1）我们的服务模式发生重大变化，如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
    </p>
    <p>
      2）我们在所有权结构、组织架构等方面发生重大变化，如业务调整、破产并购等引起的所有者变更等；
    </p>
    <p>3）个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
    <p>5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
    <p>6）个人信息安全影响评估报告表明存在高风险时。</p>
    <p>2021年12月01日</p>
    <p>北京科百宏业科技有限公司</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss"></style>
